module.exports = __webpack_public_path__ + "static/media/oops.fbdded43.png";